import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConvexQueryClient } from '@convex-dev/react-query'
import { ConvexProvider, ConvexReactClient } from 'convex/react'
import { Authenticator } from '@aws-amplify/ui-react'
import AppLayout from './shared/components/AppLayout'
import { AppRoutes } from './routes'
import { AmplifyAuthProvider, useAmplifyAuth } from './providers/AmplifyAuthProvider'
import { PageHeaderProvider } from './providers/PageHeaderProvider'
// Initialize Amplify configuration
import './lib/auth/amplifyConfig'
import '@aws-amplify/ui-react/styles.css'
import './App.css'

const convex = new ConvexReactClient((import.meta as any).env?.VITE_CONVEX_URL as string || 'https://api.alterra.smartcronos.io')
const convexQueryClient = new ConvexQueryClient(convex)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryKeyHashFn: convexQueryClient.hashFn(),
      queryFn: convexQueryClient.queryFn(),
      retry: 3,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})
convexQueryClient.connect(queryClient)

// App content component that handles authentication state
function AppContent() {
  const { user, isLoading, convexReady } = useAmplifyAuth();

  if (isLoading || !convexReady) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <PageHeaderProvider>
      <AppLayout user={user} signOut={() => {}}>
        <AppRoutes />
      </AppLayout>
    </PageHeaderProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ConvexProvider client={convex}>
        <QueryClientProvider client={queryClient}>
          <Authenticator
            signUpAttributes={[
              'email',
              'given_name',
              'family_name'
            ]}
            initialState="signIn"
            hideSignUp={true}
          >
            {() => (
              <AmplifyAuthProvider>
                <AppContent />
              </AmplifyAuthProvider>
            )}
          </Authenticator>
        </QueryClientProvider>
      </ConvexProvider>
    </BrowserRouter>
  )
}

export default App